<template>
    <AppHeader fixed class="animated slideInDown">
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.png" width="50" height="41" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo.png" width="30" height="30" alt="CoreUI Logo">
      </b-link>
     <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
      <!--  <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>-->
        <!-- <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item> -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
<!--      <AsideToggler class="d-none d-lg-block" />-->
<!--      <AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { mapState } from "vuex";
export default {
  name: 'DefaultHeader',
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler
  },
  computed:{
     ...mapState("login", ["access_token"]),

     
  }
}
</script>

<style scoped>

  /*.app-header .navbar-toggler {*/
  /*  min-width: 50px;*/
  /*  padding: 0.25rem 0;*/
  /*  visibility: hidden !important;*/
  /*}*/


  @media(max-width:768px) {
    .app-header .navbar-brand {
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 20% !important;*/
      margin-left: -100px !important;
    }
  }

</style>
